<div class="fixed transform z-1" *ngIf="showProgressSpinner">
  <app-custom-spinner></app-custom-spinner>
</div>

<div class="bg-default px-3 pb-3">
  <div class="flex justify-content-between align-items-center title-bg title-case">
    <div class="conten clean-small">
      <div class="btn"><a>Facility Benchmarks</a></div>
    </div>
    <div class="flex justify-content-end" id="facility_benchamrks_search">
      <span class="p-input-icon-left"><i class="pi pi-search"></i>
        <input pInputText type="text" [(ngModel)]="searchField" (input)="applyFilterGlobal($event, 'contains')"
          placeholder="Search Facility Benchmarks" />
          <i class="pi pi-times case-keywordsearch" *ngIf="crossSearchBool" (click)="clearSearchField()"></i>
      </span>
    </div>
  </div>

<app-common-facility-grid [commonFacilityData]="facilityBenchMarkGrid"
[totalRecords]="totalRecords"
(lazyLoadEvent)="lazyLoadSchedules($event)"
[isAccessRead]="isAccessRead" 
[isAccessReadWrite]="isAccessReadWrite"
[roleForFacility]="roleForFacility"
(onContextMenuEvent) = onContextMenu($event)
(getFacilityDetailByFacilityIdEvent)="editFacility($event.facilityId, $event.facilityName)">
</app-common-facility-grid>

  <div class="md:col-12">
    <span class="tableRefreshTime">
      Grid Last Refreshed at {{PiTeamService._currentDate}} - {{PiTeamService._currentTime}}
    </span>
  </div>
</div>
